// File: DataPrivacy.js
import React from 'react';
import { Segment, Header, Grid, Form } from 'semantic-ui-react';
import privacyData from './privacy_info.json'; // JSON file with sections

const DataPrivacy = () => {
  return (
    <Segment basic style={{ padding: '15em 2em', minWidth: '100vw', minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <Grid centered>
        <Grid.Row>
          <Header as="h2" textAlign="center">HIPAA & Data Privacy</Header>
        </Grid.Row>
        <Grid.Row>
          <Form style={{
            width: '100%',
            maxWidth: '1000px',
            margin: '0 auto',
            backgroundColor: 'white',
            padding: '2em',
            borderRadius: '10px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}>
            {privacyData.sections.map(section => (
              <Form.Field key={section.id} style={{ marginBottom: '2em', textAlign: 'left' }}>
                <Header as="h3" style={{ fontWeight: 'bold', fontSize: '22px' }}>{section.heading}</Header>
                <p style={{ fontSize: '18px', lineHeight: '1.6', marginTop: '0.5em' }}>{section.content}</p>
              </Form.Field>
            ))}
          </Form>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

export default DataPrivacy;
